import clsx from "clsx";
import { Menu, X } from "lucide-preact";
import { FunctionComponent as FC } from "preact";
import { useEffect } from "preact/hooks";
import Button from "./components/Button";
import FantasyMatchups from "./components/FantasyMatchups";
import FantasyScoreBoard from "./components/FantasyScoreBoard";
import GameComponent from "./components/Game";
import Settings from "./components/Settings";
import { useGamesStore } from "./data/games";
import { useSidebarStore } from "./data/sidebar";
import { GameStatus } from "./data/status";
import { Game, useStreamingGames } from "./data/streams";
import { useActive } from "./data/switcher";
import styles from "./App.module.css";

const App: FC = () => {
    const currentGames = useStreamingGames();
    const { playingGames } = useGamesStore();
    const activeGame = useActive();
    const { isOpen, setOpen } = useSidebarStore();

    const filteredGames = currentGames.filter(
        (g): g is { game: Game; status: GameStatus } =>
            g.game?.streamUrl ? playingGames.includes(g.game.streamUrl) : false,
    );
    const activeGameIndex = filteredGames.findIndex(
        ({ game }) => game?.streamUrl === activeGame,
    );
    const gamesLength =
        activeGameIndex >= 0 ? filteredGames.length - 1 : filteredGames.length;

    useEffect(() => {
        if (activeGame !== null) {
            window.postMessage({
                action: "mute-streams",
                streamUrl: activeGame,
            });
        }
    }, [activeGame]);

    return (
        <main className={styles.main}>
            <div className={clsx(styles.matchup, { [styles.isOpen]: isOpen })}>
                <div
                    className={clsx(styles.fantasyMatchupButton, {
                        [styles.isInside]: isOpen,
                    })}
                >
                    <Button
                        onClick={() => setOpen(!isOpen)}
                        title="Open sidebar"
                    >
                        {isOpen ? <X /> : <Menu />}
                    </Button>
                </div>
                <FantasyMatchups />
                <FantasyScoreBoard />
                <Settings />
            </div>
            <div className={styles.games}>
                {filteredGames.map(({ game, status }, index) => (
                    <GameComponent
                        key={game.streamUrl}
                        game={game}
                        status={status}
                        index={
                            activeGameIndex >= 0 && index >= activeGameIndex
                                ? index - 1
                                : index
                        }
                        length={gamesLength}
                        isActive={game.streamUrl === activeGame}
                    />
                ))}
            </div>
        </main>
    );
};

export default App;
